import { NFTCollection } from '@psychedelic/dab-js';
import { atom } from 'recoil';

export const myCollectionsState = atom<Array<NFTCollection>>({
	key: 'myCollectionsState',
	default: []
});
